define('apps/course-intro/templates/regions/header',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n    <section class=\"user-salutation\">\n        Hi";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.user)),stack1 == null || stack1 === false ? stack1 : stack1.displayName), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "!\n    </section>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += ", "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.user)),stack1 == null || stack1 === false ? stack1 : stack1.displayName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <section>\n        <a data-nav=\"route\" href='#choose-levels' class=\"back fa fa-arrow-left transition-bg\"></a>\n        Level "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.currentPage)),stack1 == null || stack1 === false ? stack1 : stack1.levelNum)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n    </section>\n    <section class=\"site_name\">Earn Your Future<sup>&reg;</sup> Digital Classroom </section>\n";
  return buffer;
  }

  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.currentPage)),stack1 == null || stack1 === false ? stack1 : stack1['show-user']), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.currentPage)),stack1 == null || stack1 === false ? stack1 : stack1['show-level']), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n<section class=\"options\">\n    <a href=\"/auth/logout\" class=\"sign-out transition-border\">Sign Out<span class=\"fa fa-sign-out\"></span></a>\n</section>\n<section class=\"options tools\">\n</section>\n";
  return buffer;
  })

});
